export function isInternalUser(email: string): boolean {
  return email.endsWith('@deepbluedot.io');
}
